import React, { Component } from 'react';

import styles from './styles.less';

interface Props {
	name: string;
	children: React.ReactNode;
	title?: string;
}

export default class Icon extends Component<Props> {
	static defaultProps = {
		children: null,
	};

	render() {
		const { name, children, title, ...props } = this.props;

		return (
			<span
				className={styles[`icon-${name}` as keyof (typeof styles)['locals']]}
				data-testid={`icon-${name}`}
				{...props}
				title={title}
			>
				<i />
				<span>{children}</span>
			</span>
		);
	}
}
